import { createActions, createReducer } from 'reduxsauce'

import DescricaoMetaService from '../servicos/DescricaoMetaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDescricaoMetaInicio: [],
    buscaDescricaoMetaSucesso: ['descricaoMeta'],
    buscaDescricaoMetaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDescricaoMeta = () => {
    return dispatch => {
        dispatch(Creators.buscaDescricaoMetaInicio())
        let serv = new DescricaoMetaService()
        return serv
            .getDescricaoResumida()
            .then(response => dispatch(Creators.buscaDescricaoMetaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDescricaoMetaErro(error)))
    }
}

const buscaDescricaoMetaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDescricaoMetaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDescricaoMetaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.descricaoMeta, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESCRICAO_META_INICIO]: buscaDescricaoMetaInicio,
    [Types.BUSCA_DESCRICAO_META_ERRO]: buscaDescricaoMetaErro,
    [Types.BUSCA_DESCRICAO_META_SUCESSO]: buscaDescricaoMetaSucesso,
})
